'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _f3tch = require('f3tch');

var _f3tch2 = _interopRequireDefault(_f3tch);

var _createdEvent = require('../events/created.event.vehicle');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function () {
  var _ref = (0, _asyncToGenerator3.default)(
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee(vehicle) {
    var response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _f3tch2.default)('/vehicles/').profile('json').body((0, _stringify2.default)(vehicle)).post();

          case 2:
            response = _context.sent;
            (0, _createdEvent.pub)(response);
            return _context.abrupt('return', response);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(); // Events